"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var object_hash_1 = __importDefault(require("object-hash"));
var material_ui_chip_input_1 = __importDefault(require("material-ui-chip-input"));
var lodash_1 = require("lodash");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var UasChipInput = function (props) { return react_1.default.createElement(material_ui_chip_input_1.default, __assign({}, props)); };
var ComposedInput = recompose_1.compose(recompose_1.pure, recompose_1.renameProp('label', 'hintText'), recompose_1.defaultProps({
    openOnFocus: true,
    labelFunction: lodash_1.identity,
    valueFunction: lodash_1.identity,
    hashFn: object_hash_1.default,
    items: [],
    value: [],
    onChange: lodash_1.noop,
    onNewItem: lodash_1.identity,
    dataSourceConfig: {
        text: 'text',
        value: 'value',
    },
    popoverProps: {
        canAutoPosition: true,
    },
    menuProps: {
        maxHeight: 250,
    },
    fullWidthInput: true,
}), recompose_1.mapProps(function (_a) {
    var items = _a.items, rest = __rest(_a, ["items"]);
    return (__assign({ dataSource: items.map(function (item) { return ({
            text: rest.labelFunction(item),
            value: rest.valueFunction(item),
            item: true,
        }); }) }, rest));
}), recompose_1.withProps(function (props) { return ({
    hashMap: lodash_1.keyBy(props.dataSource, function (v) { return props.hashFn(v.value); }),
}); }), recompose_1.withHandlers({
    onRequestAdd: function (_a) {
        var onChange = _a.onChange, value = _a.value, searchText = _a.searchText, onNewItem = _a.onNewItem;
        return function (chip) {
            onChange(__spread(value, [chip.item ? chip.value : onNewItem(chip.value)]));
        };
    },
    onRequestDelete: function (_a) {
        var onChange = _a.onChange, value = _a.value;
        return function (chip, index) {
            onChange(value.filter(function (_, i) { return i !== index; }));
        };
    },
}), recompose_1.mapProps(function (_a) {
    var hashFn = _a.hashFn, labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, onNewItem = _a.onNewItem, hashMap = _a.hashMap, openOnFocus = _a.openOnFocus, value = _a.value, rest = __rest(_a, ["hashFn", "labelFunction", "valueFunction", "onNewItem", "hashMap", "openOnFocus", "value"]);
    return __assign({ value: value.map(function (v) { return hashMap[hashFn(v)] || v; }), openOnFocus: rest.disabled === true ? false : openOnFocus }, rest);
}))(UasChipInput);
exports.default = ComposedInput;
exports.FormChipInput = reduxFormWrappers_1.arrayWrapper(ComposedInput);
//# sourceMappingURL=ChipInput.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ChipInput.js
// module id = 1122
// module chunks = 0